(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  // Apply the announcement's discount code, then go to the link's page.
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[data-discount]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
    event.preventDefault();
    var go = function () { window.location.href = link.href; };
    fetch('/discount/' + encodeURIComponent(link.dataset.discount) + '?redirect=%2Fcart.js', { credentials: 'same-origin' }).then(go, go);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  // A cart page restored from the back/forward cache has stale item keys and line numbers, so reload it
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && document.querySelector('.ora-cart')) window.location.reload();
  });

  // "Add the digital file of this design": same design properties, marked as a digital file, then reload
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-addon-digital]');
    if (!btn) return;
    btn.disabled = true;
    // Copy the design exactly as the cart stores it (read from /cart.js, so nothing is re-escaped)
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var line = cart.items.filter(function (i) { return i.key === btn.getAttribute('data-addon-key'); })[0];
        if (!line) return null;
        var props = Object.assign({}, line.properties);
        props['Frame'] = 'None (digital file)';
        props['Format'] = 'Digital file (print-ready, sent on WhatsApp or email)';
        props['_frame'] = 'none';
        props['_format'] = 'digital';
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-addon-digital')), quantity: 1, properties: props }] })
        });
      })
      .catch(function () {})
      .then(function () { window.location.reload(); });
  });

  // Remove in the background, then reload the cart. If the item already changed, the customer
  // simply sees their current cart instead of Shopify's "no valid id" error page.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-cart-remove]');
    if (!link) return;
    var root = link.closest('.ora-cart');
    e.preventDefault();
    link.setAttribute('aria-disabled', 'true');
    fetch(root.dataset.cartChangeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: link.dataset.cartRemove, quantity: 0 })
    }).catch(function () {}).then(function () { window.location.href = root.dataset.cartUrl; });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-ora-product]').forEach(function (root) {
      var variantsEl = root.querySelector('[data-ora-variants]');
      var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
      var form = root.querySelector('[data-ora-form]');
      if (!form) return;
      var idInput = form.querySelector('[data-ora-variant-id]');
      var mainImg = root.querySelector('.ora-main-image');
      var addBtn = form.querySelector('[data-ora-add]');
      var format = root.dataset.moneyFormat || ('{' + '{amount}' + '}');
      var money = function (cents) {
        var whole = Math.floor(cents / 100), frac = String(cents % 100).padStart(2, '0');
        var grouped = function (sep) { return String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
        var amount = grouped(',') + (frac === '00' ? '' : '.' + frac);
        return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
          if (k === 'amount_no_decimals') return grouped(',');
          if (k === 'amount_with_comma_separator') return grouped('.') + (frac === '00' ? '' : ',' + frac);
          if (k === 'amount_no_decimals_with_comma_separator') return grouped('.');
          return amount;
        });
      };

      function selectedOptions() {
        return Array.prototype.map.call(form.querySelectorAll('[data-ora-option]'), function (fs) {
          var c = fs.querySelector('input:checked');
          return c ? c.value : null;
        });
      }

      function update() {
        var opts = selectedOptions();
        var v = variants.find(function (x) {
          return opts.every(function (o, i) { return x.options[i] === o; });
        });
        if (!v) return;
        idInput.value = v.id;
        root.querySelectorAll('[data-ora-price]').forEach(function (el) { el.textContent = money(v.price); });
        var t = root.querySelector('[data-ora-variant-title]');
        if (t) t.textContent = '· ' + v.title;
        if (addBtn) {
          addBtn.disabled = !v.available;
          var p = addBtn.querySelector('[data-ora-btn-price]');
          if (p) p.textContent = money(v.price);
        }
        if (v.featured_image && mainImg) {
          mainImg.removeAttribute('srcset');
          mainImg.src = v.featured_image.src;
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }

      form.addEventListener('change', function (e) {
        if (e.target.closest('[data-ora-option]')) update();
        if (e.target.matches('[data-ora-frame]')) {
          var frame = root.querySelector('[data-ora-preview-frame]');
          if (frame) frame.className = 'ora-frame ora-frame--' + e.target.dataset.oraFrame;
          var name = root.querySelector('[data-ora-frame-name]');
          if (name) name.textContent = e.target.value;
        }
      });

      form.querySelectorAll('[data-ora-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          var q = form.querySelector('input[name="quantity"]');
          q.value = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(b.dataset.oraQty, 10));
        });
      });

      root.querySelectorAll('[data-ora-thumb]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!mainImg) return;
          mainImg.removeAttribute('srcset');
          mainImg.src = b.dataset.oraThumb;
          root.querySelectorAll('[data-ora-thumb]').forEach(function (x) { x.removeAttribute('aria-current'); });
          b.setAttribute('aria-current', 'true');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ora-signature"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      if (root.dataset.sliderReady) return;
      root.dataset.sliderReady = '1';
      var track = root.querySelector('[data-slider-track]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-slider-dot]'));
      var pauseBtn = root.querySelector('[data-slider-pause]');
      if (slides.length < 2) return;
      var current = 0, focused = false;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var stopped = reduce || root.dataset.autoplay !== 'true';
      root.style.setProperty('--sig-interval', Math.max(3, parseInt(root.dataset.interval, 10) || 6) + 's');

      function go(i) {
        current = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[current].offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
        mark();
      }
      function mark() {
        tabs.forEach(function (t, i) {
          // Re-set aria-current so the progress line restarts from empty on the new tab
          t.removeAttribute('aria-current');
          if (i === current) { void t.offsetWidth; t.setAttribute('aria-current', 'true'); }
        });
        slides.forEach(function (s, i) { s.toggleAttribute('inert', i !== current); });
      }
      function state() {
        root.classList.toggle('is-stopped', stopped);
        root.classList.toggle('is-static', stopped);
        root.classList.toggle('is-paused', !stopped && (focused || document.hidden));
        if (pauseBtn) pauseBtn.setAttribute('aria-label', stopped ? pauseBtn.dataset.labelPlay : pauseBtn.dataset.labelPause);
      }
      // The gold line fills over the slide's time; when it is full, move on
      tabs.forEach(function (t) {
        t.querySelector('.ora-signature__fill').addEventListener('animationend', function () {
          if (!stopped && t.getAttribute('aria-current') === 'true') go(current + 1);
        });
        t.addEventListener('click', function () { go(+t.dataset.sliderDot); });
      });
      if (pauseBtn) pauseBtn.addEventListener('click', function () { stopped = !stopped; state(); if (!stopped) mark(); });

      // Swiping: work out the slide once scrolling settles
      var settle = null;
      track.addEventListener('scroll', function () {
        clearTimeout(settle);
        settle = setTimeout(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== current && i >= 0 && i < slides.length) { current = i; mark(); }
        }, 120);
      }, { passive: true });

      // Pause only for keyboard users moving through the slide (Tab key), not after a mouse click or tap
      root.addEventListener('focusin', function (e) {
        focused = e.target !== pauseBtn && !e.target.hasAttribute('data-slider-dot') && e.target.matches(':focus-visible');
        state();
      });
      root.addEventListener('focusout', function () { focused = false; state(); });
      document.addEventListener('visibilitychange', state);
      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') go(current - 1);
        if (e.key === 'ArrowRight') go(current + 1);
      });
      // Theme editor: show the slide being edited
      document.addEventListener('shopify:block:select', function (e) {
        var i = slides.indexOf(e.target.closest('[data-slide]'));
        if (i > -1) { stopped = true; state(); go(i); }
      });
      mark();
      state();
    }
    function init() { document.querySelectorAll('[data-ora-slider]').forEach(setup); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ora-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var cards = Array.prototype.slice.call(root.querySelectorAll('.ora-rv__card'));
      var perPage = parseInt(root.dataset.perPage, 10) || 6;
      var more = root.querySelector('[data-more]');
      var empty = root.querySelector('[data-empty]');
      var shown = perPage;
      var filter = { type: 'all', value: '' };

      function matches(c) {
        if (filter.type === 'stars') return c.dataset.stars === filter.value;
        if (filter.type === 'photos') return c.dataset.photo === '1';
        if (filter.type === 'product') return c.dataset.product === filter.value;
        return true;
      }
      function render() {
        var visible = cards.filter(matches);
        cards.forEach(function (c) { c.classList.add('is-hidden'); });
        visible.slice(0, shown).forEach(function (c) { c.classList.remove('is-hidden'); });
        more.hidden = visible.length <= shown;
        empty.hidden = visible.length > 0;
      }
      function press(btn) {
        root.querySelectorAll('[data-filter], [data-filter-stars], [data-filter-product]').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      }
      root.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b || !root.contains(b)) return;
        if (b.hasAttribute('data-more')) { shown += perPage; render(); return; }
        if (b.hasAttribute('data-jump')) {
          var card = root.querySelector('#review-' + b.dataset.jump);
          filter = { type: 'all', value: '' }; shown = cards.length; press(root.querySelector('[data-filter="all"]')); render();
          if (card) { card.scrollIntoView({ behavior: 'smooth', block: 'center' }); card.classList.add('is-flash'); setTimeout(function () { card.classList.remove('is-flash'); }, 1600); }
          return;
        }
        var same = b.getAttribute('aria-pressed') === 'true';
        if (b.hasAttribute('data-filter-stars')) filter = same ? { type: 'all' } : { type: 'stars', value: b.dataset.filterStars };
        else if (b.hasAttribute('data-filter-product')) filter = same ? { type: 'all' } : { type: 'product', value: b.dataset.filterProduct };
        else if (b.dataset.filter === 'photos') filter = same ? { type: 'all' } : { type: 'photos' };
        else if (b.dataset.filter === 'all') filter = { type: 'all' };
        else return;
        shown = perPage;
        press(filter.type === 'all' ? root.querySelector('[data-filter="all"]') : b);
        render();
      });
      render();
    }
    function init() { document.querySelectorAll('[data-ora-reviews]').forEach(setup); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
